import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginSubjectLinkContainerModel } from "../../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../../shared";

@Injectable({providedIn: 'root'})
export class LoginSubjectLinkService extends BaseApiTemplateService<LoginSubjectLinkContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'login-subject-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'login-subject-link';
    this.httpClient = http;
  }
}
